/** @format */

import React, { useState, useEffect } from "react";
import Accordion from "react-bootstrap/Accordion";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import AccordionHeader from "./accordionHeader";
import AccordionBody from "./accordionBody";
import * as typingCenterUserActions from "../../Redux/Actions/typingCenterUser";
import { setJobId, setName, setEmail, setMobileNumber, setEmiratesId, setClearFilterFlag, reset } from '../../Redux/Reducers/cspInfoFilter';

function CspInfo() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [cspData, setCspData] = useState({
    data: [],
  });

  const { staffId, name, email, mobileNumber, emiratesId, clearFilterFlag } = useSelector((state) => state.cspInfoFilter);

  useEffect(() => {
    getAllApi();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearFilterFlag]);

  const getAllApi = async () => {
    const payload = {
      staffId,
      name,
      email,
      mobileNo: mobileNumber,
      emiratesId,
    };
    const { data } = await typingCenterUserActions.getCspStaffs(payload);
    setCspData((prevState) => ({ ...prevState, data }));
  };

  const changeHandler = (setState) => (event) => dispatch(setState(event.target.value));

  const filterHandler = () => {
        if(staffId || name || email || mobileNumber || emiratesId) {
            dispatch(setClearFilterFlag(clearFilterFlag +1));
        }
    };

  return (
    <div className="container-fluid">
      <div className="page-title-box">
        <h4 className="page-title my-2">{t("userManagement.cspInfo.title")}</h4>
      </div>
      <div className="row">
        <div className="col-lg-12 col-xxl-12">
          <div className="card card-custom card-stretch gutter-b">
            <div className="card-body py-3">
              <div className="tab-content">
                <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex">
                        <div className="me-3" style={{ width: '100%' }}>
                            <label className="mb-1 ms-1 me-3">{t("userManagement.cspInfo.staffId")}</label>
                            <input placeholder={t("userManagement.cspInfo.enterStaffId")} type="text" className="form-control me-3" value={staffId} onChange={changeHandler(setJobId)} />
                        </div>
                        <div className="me-3" style={{ width: '100%' }}>
                            <label className="mb-1 ms-1 me-3">{t("userManagement.cspInfo.name")}</label>
                            <input placeholder={t("userManagement.cspInfo.enterName")} type="text" className="form-control me-3" value={name} onChange={changeHandler(setName)}/>
                        </div>
                        <div className="me-3" style={{ width: '100%' }}>
                            <label className="mb-1 ms-1 me-3">{t("userManagement.cspInfo.email")}</label>
                            <input placeholder={t("userManagement.cspInfo.enterEmail")} type="email" className="form-control me-3" value={email} onChange={changeHandler(setEmail)}/>
                        </div>
                        <div className="me-3" style={{ width: '100%' }}>
                            <label className="mb-1 ms-1 me-3">{t("userManagement.cspInfo.mobileNumber")}</label>
                            <input placeholder={t("userManagement.cspInfo.enterMobileNumber")} type="text" className="form-control me-3" value={mobileNumber} onChange={changeHandler(setMobileNumber)}/>
                        </div>
                        <div className="me-3" style={{ width: '100%' }}>
                            <label className="mb-1 ms-1 me-3">{t("userManagement.cspInfo.emiratesId")}</label>
                            <input placeholder={t("userManagement.cspInfo.enterEmiratesId")} type="text" className="form-control me-3" value={emiratesId}  onChange={changeHandler(setEmiratesId)}/>
                        </div>
                    </div>
                </div>
                <div className="d-flex align-items-center mb-3">
                    <div className="d-flex align-items-end mb-3" style={{ width: '12%', whiteSpace: 'nowrap'}}>
                        <button type="button" className="d-flex px-5 align-items-center btn btn-primary font-weight-bold" onClick={filterHandler}>{t("jobsManagement.filters.filter")}</button>
                    </div>
                    <div className="d-flex align-items-end mb-3 " style={{ width: '12%', whiteSpace: 'nowrap' }}>
                        <button type="button" className="px-5 d-flex align-items-center btn btn-primary font-weight-bold" onClick={() => dispatch(reset())} >{t("jobsManagement.filters.clearFilters")}</button>
                    </div>
                </div>
                <Accordion>
                  {cspData.data.map(
                    ({ staffDetails, id, ...headerData }, i) => (
                      <Accordion.Item eventKey={i.toString()} key={id}>
                        <AccordionHeader data={headerData} />
                        <AccordionBody data={staffDetails} />
                      </Accordion.Item>
                    )
                  )}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CspInfo;
